import { apiRequest } from './client';
import {
  BulkOperation,
  CreateBulkOperationRequest,
  UpdateBulkOperationRequest,
  AddReceiptsToBulkOperationRequest,
} from './types';

// Get all bulk operations for authenticated user
export const getBulkOperations = async (
  token: string
): Promise<BulkOperation[]> => {
  return await apiRequest<BulkOperation[]>({
    endpoint: '/bulk-operations',
    method: 'GET',
    token,
  });
};

// Get a specific bulk operation by ID
export const getBulkOperationById = async (
  bulkOperationId: string,
  token: string
): Promise<BulkOperation> => {
  return await apiRequest<BulkOperation>({
    endpoint: `/bulk-operations/${bulkOperationId}`,
    method: 'GET',
    token,
  });
};

// Create a new bulk operation
export const createBulkOperation = async (
  request: CreateBulkOperationRequest,
  token: string
): Promise<BulkOperation> => {
  return apiRequest<BulkOperation>({
    endpoint: '/bulk-operations',
    method: 'POST',
    token,
    body: request,
  });
};

// Update a bulk operation (title and/or description)
export const updateBulkOperation = async (
  bulkOperationId: string,
  request: UpdateBulkOperationRequest,
  token: string
): Promise<BulkOperation> => {
  return apiRequest<BulkOperation>({
    endpoint: `/bulk-operations/${bulkOperationId}`,
    method: 'PATCH',
    token,
    body: request,
  });
};

// Add receipts to an existing bulk operation
export const addReceiptsToBulkOperation = async (
  bulkOperationId: string,
  request: AddReceiptsToBulkOperationRequest,
  token: string
): Promise<BulkOperation> => {
  return apiRequest<BulkOperation>({
    endpoint: `/bulk-operations/${bulkOperationId}/receipts`,
    method: 'POST',
    token,
    body: request,
  });
};

// Remove a receipt from a bulk operation
export const removeReceiptFromBulkOperation = async (
  bulkOperationId: string,
  receiptId: string,
  token: string
): Promise<BulkOperation> => {
  return apiRequest<BulkOperation>({
    endpoint: `/bulk-operations/${bulkOperationId}/receipts/${receiptId}`,
    method: 'DELETE',
    token,
  });
};

// Delete a bulk operation
export const deleteBulkOperation = async (
  bulkOperationId: string,
  token: string
): Promise<void> => {
  return apiRequest<void>({
    endpoint: `/bulk-operations/${bulkOperationId}`,
    method: 'DELETE',
    token,
  });
};

// Generate booking data for all receipts in a bulk operation (async, returns 202)
export const generateBulkOperation = async (
  bulkOperationId: string,
  token: string
): Promise<void> => {
  return apiRequest<void>({
    endpoint: `/bulk-operations/${bulkOperationId}/generate`,
    method: 'POST',
    token,
  });
};

// Import all generated bookings in a bulk operation (async, returns 202)
export const importBulkOperation = async (
  bulkOperationId: string,
  token: string
): Promise<void> => {
  return apiRequest<void>({
    endpoint: `/bulk-operations/${bulkOperationId}/import`,
    method: 'POST',
    token,
  });
};
